/**
 * Validates a French phone number.
 * Accepts formats: +33 6 12 34 56 78, 0033 6 12 34 56 78, 06 12 34 56 78
 * Separators can be spaces, dots, or dashes.
 */
export function validatePhone(val: string): boolean {
  const regex = /^(?:(?:\+|00)[0-9]{2}|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;
  return regex.test(val.trim());
}

/**
 * Validates an email address.
 */
export function validateEmail(val: string): boolean {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(val.trim());
}

/**
 * Validates a French postal code (5 digits).
 */
export function validatePostalCode(val: string): boolean {
  const regex = /^\d{5}$/;
  return regex.test(val.trim());
}

/**
 * Validates that a string is not empty after trimming whitespace.
 */
export function validateRequired(val: string): boolean {
  return val.trim().length > 0;
}

/**
 * Le choix de la commune est exigé dès lors que le référentiel en a proposé au
 * moins une. Un code postal inconnu du référentiel (CEDEX, code récent, panne
 * réseau) ne bloque pas la soumission : mieux vaut un lead sans commune qu'un
 * lead perdu sur la dernière étape.
 *
 * `null` = liste en cours de chargement. Ni le compte ni `ville` ne sont
 * encore fiables : on refuse la soumission plutôt que de valider sur un état
 * périmé (commune absente, ou commune de l'ancien code postal).
 */
export function validateCommune(ville: string, communesCount: number | null): boolean {
  if (communesCount === null) return false;
  return communesCount === 0 || ville.trim().length > 0;
}

/**
 * Code postal contenu dans la saisie du champ commune, qui porte après
 * sélection un libellé complet (« 13100 - Aix-en-Provence »). Renvoie "" tant
 * que les cinq chiffres ne sont pas là — le funnel garde alors un code postal
 * vide plutôt qu'un fragment.
 */
export function extractCodePostal(saisie: string): string {
  const m = saisie.trim().match(/^(\d{5})/);
  return m ? m[1] : "";
}
